import { DrawerComponent } from '../../components/kt/components'

export class DrawerStore {
   static readonly store: Map<string, DrawerComponent> = new Map()

   public static set(instanceId: string, drawerComponentObj: DrawerComponent): void {
      if (DrawerStore.has(instanceId)) {
         return
      }

      DrawerStore.store.set(instanceId, drawerComponentObj)
   }

   public static get(instanceId: string): DrawerComponent | undefined {
      if (!DrawerStore.has(instanceId)) {
         return
      }
      return DrawerStore.store.get(instanceId)
   }

   public static remove(instanceId: string): void {
      if (!DrawerStore.has(instanceId)) {
         return
      }

      DrawerStore.store.delete(instanceId)
   }

   public static has(instanceId: string): boolean {
      return DrawerStore.store.has(instanceId)
   }

   public static getAllInstances() {
      return DrawerStore.store
   }
}
